import React, { useState, useEffect } from 'react';
import { getSharedFilters, saveSharedFilters } from '../../utils/filterStore';
import { UploadCloud, TrendingUp, DollarSign, ShoppingBag, BarChart2, CheckCircle, Store, Box, Calendar, Filter, FileText, ChevronDown, Check, Download, FileSpreadsheet } from 'lucide-react';
import ReactECharts from 'echarts-for-react';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { API_URL as CONFIG_API_URL } from '../../config';
const BASE_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';

const engineLogos = {
  /* INJECTED_MB_PC_LOGOS_v2 */
  '豆包': '/icons/doubao.png',
  '豆包(PC)': '/icons/doubao.png',
  '豆包(MB)': '/icons/doubao.png',
  '豆包（PC）': '/icons/doubao.png',
  '豆包（MB）': '/icons/doubao.png',
  'doubao': '/icons/doubao.png',
  '腾讯元宝(PC)': '/icons/yuanbao.png',
  '腾讯元宝(MB)': '/icons/yuanbao.png',
  '腾讯元宝（PC）': '/icons/yuanbao.png',
  '腾讯元宝（MB）': '/icons/yuanbao.png',
  '通义千问': '/icons/tongyi.png',
  '通义千问(PC)': '/icons/tongyi.png',
  '通义千问(MB)': '/icons/tongyi.png',
  '通义千问（PC）': '/icons/tongyi.png',
  '通义千问（MB）': '/icons/tongyi.png',
  '通义': '/icons/tongyi.png',
  '文心一言': '/icons/wenxin.png',
  '文心一言(PC)': '/icons/wenxin.png',
  '文心一言(MB)': '/icons/wenxin.png',
  'Deepseek': '/icons/deepseek.png',
  'DeepSeek': '/icons/deepseek.png',
  'deepseek': '/icons/deepseek.png',
  'Kimi': '/icons/kimi.png',
  'kimi': '/icons/kimi.png',
  '元宝': '/icons/yuanbao.png',
  '百度AI搜索': '/icons/baidu.png',
  '小红书AI': '/icons/xiaohongshu.png',
  '抖音AI': '/icons/douyin.png',
  '小红书': '/icons/xiaohongshu.png',
  'xhs': '/icons/xiaohongshu.png',
  '微信搜一搜': '/icons/wechat.png',
  '微信': '/icons/wechat.png',
};

export default function CommerceAnalytics() {
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [importing, setImporting] = useState(false);
  const [data, setData] = useState(null);
  
  // Filters
  const [filters, setFilters] = useState(() => getSharedFilters({
    time: '最近 30 天',
    customDate: { start: '', end: '' },
    engines: ['全部 AI 引擎']
  }));
  
  useEffect(() => {
    saveSharedFilters(filters);
  }, [filters]);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (key) => setOpenDropdown(prev => prev === key ? null : key);
  
  const updateTimeFilter = (val) => {
    setFilters(p => ({ ...p, time: val }));
    if (val !== '自定义范围') setOpenDropdown(null);
  };
  
  const toggleArrayFilter = (key, val, allLabel) => {
    setFilters(p => {
      let current = [...p[key]];
      if (val === allLabel) {
        current = [allLabel];
      } else {
        current = current.filter(item => item !== allLabel);
        if (current.includes(val)) {
          current = current.filter(item => item !== val);
          if (current.length === 0) current = [allLabel];
        } else {
          current.push(val);
        }
      }
      return { ...p, [key]: current };
    });
  };

  const renderArrayLabel = (arr, allLabel) => {
    if (arr.includes(allLabel)) return allLabel;
    if (arr.length === 1) return arr[0];
    return `已选 ${arr.length} 项`;
  };

  const fetchAttribution = async () => {
    try {
      setLoading(true);
      const projectId = localStorage.getItem('globalBrand') || 1;
      
      // Map custom engines to API param
      const engineParam = filters.engines.includes('全部 AI 引擎') ? 'all' : filters.engines.join(',');
      
      let startDate = undefined;
      let endDate = undefined;
      if (filters.time === '最近 7 天') {
         const d = new Date(); d.setDate(d.getDate() - 7); startDate = d.toISOString(); endDate = new Date().toISOString();
      } else if (filters.time === '最近 30 天') {
         const d = new Date(); d.setDate(d.getDate() - 30); startDate = d.toISOString(); endDate = new Date().toISOString();
      } else if (filters.time === '最近 90 天') {
         const d = new Date(); d.setDate(d.getDate() - 90); startDate = d.toISOString(); endDate = new Date().toISOString();
      } else if (filters.time === '自定义范围') {
         if (filters.customDate.start) startDate = new Date(filters.customDate.start).toISOString();
         if (filters.customDate.end) {
            const end = new Date(filters.customDate.end);
            end.setHours(23,59,59,999);
            endDate = end.toISOString();
         }
      }

      let url = `${BASE_URL}/compass/attribution?brandProjectId=${projectId}&engine=${engineParam}`;
      if (startDate) url += `&startDate=${startDate}`;
      if (endDate) url += `&endDate=${endDate}`;
      const globalProject = localStorage.getItem('globalProject');
      if (globalProject && globalProject !== 'all' && globalProject !== 'undefined') {
          url += `&geoTaskId=${globalProject}`;
      }


      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const res = await axios.get(url, { headers });
      if (res.data.success) {
        setData(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAttribution();
    const handleGlobalFilterChange = () => fetchAttribution();
    window.addEventListener('globalFilterChange', handleGlobalFilterChange);
    return () => window.removeEventListener('globalFilterChange', handleGlobalFilterChange);
  }, [filters]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.relative')) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleExportImage = async () => {
    const contentElement = document.getElementById('report-content');
    if (!contentElement) return;
    try {
      const canvas = await html2canvas(contentElement, { scale: 2, useCORS: true, backgroundColor: document.documentElement.classList.contains('dark') ? '#0f172a' : '#ffffff' });
      const image = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = image;
      link.download = `流量归因分析_${new Date().toISOString().slice(0, 10)}.png`;
      link.click();
    } catch (error) {
      console.error('Failed to export image', error);
    }
  };

  const handleExportExcel = () => {
    if (!data) return;
    
    // 1. KPI Data
    const kpiSheetData = [
      ['大模型直接归因 GMV', '订单笔数', '平均客单价', '最高单日爆发 GMV'],
      [
        data.summary.totalGmv || 0, 
        data.summary.totalOrders || 0, 
        data.summary.totalOrders > 0 ? (data.summary.totalGmv / data.summary.totalOrders).toFixed(1) : 0,
        (data.timeline && data.timeline.gmv && data.timeline.gmv.length > 0) ? Math.max(...data.timeline.gmv) : 0
      ]
    ];

    // 2. Timeline Data
    const timelineSheetData = [['日期', 'GMV(元)', 'SOV(%)']];
    if (data.timeline && data.timeline.dates) {
      data.timeline.dates.forEach((date, i) => {
        timelineSheetData.push([date, data.timeline.gmv[i], data.timeline.sov ? data.timeline.sov[i] : '-']);
      });
    }

    const wsKpi = XLSX.utils.aoa_to_sheet(kpiSheetData);
    const wsTimeline = XLSX.utils.aoa_to_sheet(timelineSheetData);
    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsKpi, "核心指标");
    XLSX.utils.book_append_sheet(wb, wsTimeline, "趋势数据");
    
    XLSX.writeFile(wb, `流量归因分析数据_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  // eslint-disable-next-line no-unused-vars
  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setImporting(true);
      const projectId = localStorage.getItem('globalBrand') || 1;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('projectId', projectId);

      const token = localStorage.getItem('token');
      const headers = { 'Content-Type': 'multipart/form-data' };
      if (token) headers.Authorization = `Bearer ${token}`;

      const res = await axios.post(`${BASE_URL}/compass/import`, formData, { headers });
      if (res.data.success) {
        alert(res.data.message);
        fetchAttribution();
      }
    } catch (err) {
      alert("导入失败: " + err.message);
    } finally {
      setImporting(false);
      e.target.value = null; // reset
    }
  };

  // ECharts config
  const chartOption = data ? {
    tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
    legend: { data: ['实际成交GMV (元)', 'AI大模型展现声量 (SOV%)'], textStyle: { color: '#94a3b8' } },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { 
      type: 'category', 
      data: data.timeline.dates,
      axisLabel: { color: '#94a3b8' }
    },
    yAxis: [
      {
        type: 'value',
        name: 'GMV (元)',
        nameTextStyle: { color: '#94a3b8' },
        axisLabel: { color: '#94a3b8' },
        splitLine: { lineStyle: { color: '#334155', type: 'dashed' } }
      },
      {
        type: 'value',
        name: 'SOV (%)',
        nameTextStyle: { color: '#94a3b8' },
        axisLabel: { color: '#94a3b8', formatter: '{value} %' },
        splitLine: { show: false }
      }
    ],
    series: [
      {
        name: '实际成交GMV (元)',
        type: 'bar',
        yAxisIndex: 0,
        itemStyle: { color: '#3b82f6', borderRadius: [4, 4, 0, 0] },
        data: data.timeline.gmv
      },
      {
        name: 'AI大模型展现声量 (SOV%)',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        itemStyle: { color: '#10b981' },
        data: data.timeline.sov
      }
    ]
  } : {};

  const channelOption = data ? {
    tooltip: { trigger: 'item', formatter: '{b}: {c}元 ({d}%)' },
    legend: { bottom: '0%', textStyle: { color: '#94a3b8' } },
    series: [
      {
        name: '平台渠道',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#1e293b',
          borderWidth: 2
        },
        label: { show: false },
        data: data.channels
      }
    ]
  } : {};

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-2">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <TrendingUp className="text-emerald-500 w-6 h-6" />
            AI 转化归因审计 (ROI Attribution)
          </h1>
          <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">
            打通大模型商品卡位 (Sapient Rank) 与 电商真实成交 (Compass/罗盘)，评估确定的 AI 种草价值。
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#8B84AD] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportExcel}
          >
            <FileSpreadsheet className="w-4 h-4" />
            导出数据
          </button>
          <button 
            className="flex items-center gap-2 px-4 py-2 bg-[#9EA9DF] text-white rounded-lg shadow-sm hover:opacity-90 transition-colors text-sm font-medium"
            onClick={handleExportImage}
          >
            <Download className="w-4 h-4" />
            导出图片
          </button>
        </div>
      </div>

      <div id="report-content" className="space-y-6">
       {/* Global Filter Bar */}
      <div className="relative z-40 bg-white dark:bg-slate-800/80 backdrop-blur-xl border border-gray-100 dark:border-slate-700/50 rounded-lg p-3 mb-6 flex flex-wrap items-center gap-3 shadow-sm">
        <div className="flex items-center text-sm font-medium text-gray-700 dark:text-slate-300 mr-2">
          <Filter size={16} className="mr-2 text-blue-500" /> 数据筛选
        </div>
        
        {/* Time Filter */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('time')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <Calendar size={14} />
            <span>{filters.time === '自定义范围' && filters.customDate.start ? `${filters.customDate.start} 至 ${filters.customDate.end}` : filters.time}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'time' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'time' && (
            <div className="absolute top-full left-0 mt-1 w-64 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              {['最近 7 天', '最近 30 天', '最近 90 天', '全部时间', '自定义范围'].map(opt => (
                <div key={opt} onClick={() => updateTimeFilter(opt)} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex justify-between items-center">
                  <span>{opt}</span>
                  {filters.time === opt && <Check size={14} className="text-blue-500" />}
                </div>
              ))}
              {filters.time === '自定义范围' && (
                <div className="px-4 py-3 bg-gray-50 dark:bg-slate-900/50 border-t border-gray-100 dark:border-slate-700 space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">开始</span>
                    <input type="date" value={filters.customDate.start} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, start: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">结束</span>
                    <input type="date" value={filters.customDate.end} onChange={(e) => setFilters(p => ({...p, customDate: {...p.customDate, end: e.target.value}}))} className="text-xs border border-gray-300 dark:border-slate-600 rounded px-2 py-1 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300" />
                  </div>
                  <button onClick={() => setOpenDropdown(null)} className="w-full mt-2 bg-blue-500 text-white text-xs py-1.5 rounded hover:bg-blue-600 transition">确定</button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* AI Platform Filter (Multi-select) */}
        <div className="relative">
          <button 
            onClick={() => toggleDropdown('engines')}
            className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-600 rounded-md text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 transition-colors"
          >
            <span>{renderArrayLabel(filters.engines, '全部 AI 引擎')}</span>
            <ChevronDown size={14} className={`text-gray-400 transition-transform ${openDropdown === 'engines' ? 'rotate-180' : ''}`} />
          </button>
          {openDropdown === 'engines' && (
            <div className="absolute top-full left-0 mt-1 w-48 bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-md shadow-xl z-50 overflow-hidden">
              <div className="py-1">
                <div onClick={() => toggleArrayFilter('engines', '全部 AI 引擎', '全部 AI 引擎')} className="px-4 py-2 text-sm text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer flex items-center space-x-2 font-medium">
                  <input type="checkbox" checked={filters.engines.includes('全部 AI 引擎')} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                  <span>全部 AI 引擎</span>
                </div>
                
                {['Kimi', 'DeepSeek', '豆包', '文心一言', '腾讯元宝', '通义千问', '小红书AI', '抖音AI', '百度AI搜索'].map(opt => {
                  const isDisabled = opt === '百度AI搜索';
                  if (opt === '豆包' || opt === '腾讯元宝' || opt === '通义千问') {
                     const baseName = opt;
                     const pcName = baseName + '(PC)';
                     const mbName = baseName + '(MB)';
                     const isMBDisabled = false; 
                     
                     return (
                        <div key={opt} className="px-4 py-2 flex flex-col gap-2 border-b border-gray-50 dark:border-slate-800/50 hover:bg-gray-50/50 dark:hover:bg-slate-700/50">
                           <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-slate-300">
                              {engineLogos[baseName] && <img src={engineLogos[baseName]} alt={baseName} className="w-4 h-4 rounded-sm object-contain" />}
                              <span>{baseName}</span>
                           </div>
                           <div className="flex gap-2 pl-6">
                              <div onClick={(e) => { e.stopPropagation(); toggleArrayFilter('engines', pcName, '全部 AI 引擎') }} className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs cursor-pointer transition-colors border ${filters.engines.includes(pcName) ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700'}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                 <span>PC</span>
                              </div>
                              <div onClick={(e) => { 
                                  e.stopPropagation(); 
                                  if (!isMBDisabled) toggleArrayFilter('engines', mbName, '全部 AI 引擎'); 
                                }} 
                                className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors border ${isMBDisabled ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed dark:bg-slate-800/50 dark:border-slate-700 dark:text-slate-500' : (filters.engines.includes(mbName) ? 'bg-blue-50 border-blue-200 text-blue-700 cursor-pointer dark:bg-blue-900/30 dark:border-blue-800 dark:text-blue-400' : 'bg-white border-gray-200 text-gray-600 cursor-pointer hover:bg-gray-50 dark:bg-slate-800 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700')}`}>
                                 <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line></svg>
                                 <span>MB</span>
                              </div>
                           </div>
                        </div>
                     );
                  }
                  return (
                  <div 
                    key={opt} 
                    onClick={(e) => { e.stopPropagation(); if (!isDisabled) toggleArrayFilter('engines', opt, '全部 AI 引擎') }} 
                    className={`px-4 py-2 text-sm flex items-center space-x-2 ${isDisabled ? 'opacity-50 cursor-not-allowed bg-gray-50 dark:bg-slate-900 text-gray-500' : 'text-gray-700 dark:text-slate-300 hover:bg-blue-50 dark:hover:bg-slate-700 cursor-pointer'}`}
                    title={isDisabled ? "暂未开放" : ""}
                  >
                    <input type="checkbox" checked={filters.engines.includes(opt)} disabled={isDisabled} readOnly className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed" />
                    {engineLogos[opt] && <img src={engineLogos[opt]} alt={opt} className="w-4 h-4 rounded-sm object-contain" />}
                    <span>{opt}{isDisabled ? ' (暂未开放)' : ''}</span>
                  </div>
                  );
                })}

              </div>
            </div>
          )}
        </div>
      </div>

      {!data && loading && (
        <div className="py-20 flex justify-center"><div className="w-8 h-8 border-4 border-emerald-200 border-t-emerald-600 rounded-full animate-spin"></div></div>
      )}

      {data && (
        <>
          {/* KPIs */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm relative overflow-hidden">
              <div className="absolute top-0 right-0 p-4 opacity-10"><DollarSign size={48} /></div>
              <p className="text-sm text-gray-500 dark:text-slate-400">大模型直接归因 GMV</p>
              <h4 className="text-3xl font-bold text-gray-900 dark:text-white mt-2">¥{Number(data.summary.totalGmv).toLocaleString()}</h4>
            </div>
            
            <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm relative overflow-hidden">
              <div className="absolute top-0 right-0 p-4 opacity-10"><ShoppingBag size={48} /></div>
              <p className="text-sm text-gray-500 dark:text-slate-400">订单笔数</p>
              <h4 className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{data.summary.totalOrders.toLocaleString()} <span className="text-lg">笔</span></h4>
            </div>

            <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm relative overflow-hidden">
              <div className="absolute top-0 right-0 p-4 opacity-10"><BarChart2 size={48} /></div>
              <p className="text-sm text-gray-500 dark:text-slate-400">平均订单均价 (客单价)</p>
              <h4 className="text-3xl font-bold text-blue-500 mt-2">¥{data.summary.totalOrders > 0 ? (data.summary.totalGmv / data.summary.totalOrders).toFixed(1) : 0}</h4>
            </div>

            <div className="bg-white dark:bg-slate-800 rounded-xl p-5 border border-gray-100 dark:border-slate-700 shadow-sm relative overflow-hidden">
              <div className="absolute top-0 right-0 p-4 opacity-10"><TrendingUp size={48} /></div>
              <p className="text-sm text-gray-500 dark:text-slate-400">最高单日爆发 GMV</p>
              <h4 className="text-3xl font-bold text-emerald-500 mt-2">¥{data.timeline.gmv.length > 0 ? Math.max(...data.timeline.gmv).toLocaleString() : 0}</h4>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Trend Chart */}
            <div className="lg:col-span-2 bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm p-5">
              <h3 className="text-base font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <TrendingUp className="w-4 h-4 text-blue-500" />
                流量与销量的时序共振图 (Desire Transform)
              </h3>
              <div className="h-[350px] w-full">
                <ReactECharts option={chartOption} style={{ height: '100%', width: '100%' }} />
              </div>
            </div>

            {/* Channels Pie */}
            <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm p-5">
              <h3 className="text-base font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                <Box className="w-4 h-4 text-emerald-500" />
                AI渠道大盘贡献率
              </h3>
              <div className="h-[350px] w-full">
                <ReactECharts option={channelOption} style={{ height: '100%', width: '100%' }} />
              </div>
            </div>
          </div>

          {/* Top Products */}
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-sm p-5">
            <h3 className="text-base font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
              <ShoppingBag className="w-4 h-4 text-rose-500" />
              AI 种草爆款转化榜单 (Top 5)
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-slate-700 dark:text-gray-400">
                  <tr>
                    <th className="px-4 py-3">排名</th>
                    <th className="px-4 py-3">罗盘识别品类 (脱敏)</th>
                    <th className="px-4 py-3 text-center">对应AI大模型展现 (SOV)</th>
                    <th className="px-4 py-3 text-right">转化笔数</th>
                    <th className="px-4 py-3 text-right">累计GMV (元)</th>
                  </tr>
                </thead>
                <tbody>
                  {data.topProducts.map((p, idx) => (
                    <tr key={idx} className="border-b dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-700/50">
                      <td className="px-4 py-4 font-bold text-gray-900 dark:text-white">
                        <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs text-white ${idx === 0 ? 'bg-rose-500' : idx === 1 ? 'bg-amber-500' : idx === 2 ? 'bg-blue-500' : 'bg-gray-300 dark:bg-slate-600'}`}>
                          {idx + 1}
                        </span>
                      </td>
                      <td className="px-4 py-4 font-medium text-gray-900 dark:text-white max-w-[300px] truncate" title={p.productName}>
                        {p.productName}
                      </td>
                      <td className="px-4 py-4 text-center">
                        <span className="bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400 px-2.5 py-0.5 rounded-full text-xs font-bold border border-emerald-200 dark:border-emerald-800/50">
                          {p.sovShare} 霸榜率
                        </span>
                      </td>
                      <td className="px-4 py-4 text-right">{p.count}</td>
                      <td className="px-4 py-4 text-right font-bold text-rose-500">¥{Math.round(p.amount).toLocaleString()}</td>
                    </tr>
                  ))}
                  {data.topProducts.length === 0 && (
                    <tr><td colSpan="5" className="text-center py-8">暂无归因数据</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
      </div>
    </div>
  );
}
